<template lang="pug">
.buscaCar-container
    el-input#car-parcela.input(
        v-if='visivel',
        v-model='valorPesquisado',
        :placeholder='i18n.t("mensagens.menuMapa.placeholder.informeCarOuParcela")',
        @keyup.enter.native='fazerPesquisa',
        @keyup.escape.native='showInput(null)',
        clearable,
        ref='inputForm'
    )

    el-button#botao-busca-car(
        type='primary',
        :title='i18n.t("mensagens.menuMapa.placeholder.buscarCarOuParcela")',
        icon='el-icon-search',
        @click='showInput(null)',
        @keyup.escape.native='showInput(false)'
    )
</template>

<script>
import store from '@/store';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import Mapa from '@/utils/mapa/mapa.service';
import EventBus from '@/utils/eventBus';
import SigefService from '@/services/SigefService';
import formatters from '@/utils/formatters';
import i18n from '@/main';
import translate from '@/utils/translate';
import TerritorioService from '@/services/TerritorioService';

export default {
    name: 'BuscaCar',
    props: {
        mapa: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            visivel: false,
            valorPesquisado: '',
            i18n: i18n
        };
    },

    watch: {
        valorPesquisado: function (value) {
            if (value.length > 0) {
                let mascara = '';
                value = value.replace(/[^\w\s]/gi, '');

                if (value.length <= 32) {
                    mascara = formatters.formatCodigoParcela(value);
                } else {
                    mascara = formatters.formatCar(value);
                }
                this.valorPesquisado = mascara;
            }
        }
    },

    methods: {
        fecharInputAoClicarFora(event) {
            if (!this.$el.contains(event.target)) {
                this.showInput(false);
            }
        },

        showInput(visivel) {
            this.visivel = !this.visivel;
            if (this.visivel) {
                document.body.addEventListener(
                    'click',
                    this.fecharInputAoClicarFora
                );
                this.$nextTick(() => {
                    this.$refs.inputForm.focus();
                });
            } else {
                document.body.removeEventListener(
                    'click',
                    this.fecharInputAoClicarFora
                );
            }
        },

        fazerPesquisa() {
            if (!this.valorPesquisado && this.valorPesquisado === '') {
                this.$notify.error({
                    message: translate.getMessage(
                        'mensagens.menuMapa.notificacoes.informeCarOuParcela'
                    )
                });
            } else {
                if (this.valorPesquisado.length === 43) {
                    this.buscarCar();
                } else {
                    this.buscarSigef();
                }
            }
        },

        async buscarCar() {
            try {
                const { data } = await TerritorioService.findByCar(
                    this.valorPesquisado
                );
                const type = 'CAR';

                let response = data.camadas.find(el => {
                    if (el.camada.codigo === 'IMOVEL_RURAL') {
                        return el.resultados[0];
                    }
                }).resultados[0];

                const resultado = {
                    ...response,
                    ...response.properties,
                    type,
                    identificadorGeometria: this.valorPesquisado
                };

                this.carSelected = {
                    codigo: resultado.codigo,
                    condicao: resultado.condicao
                };

                this.gemotryByCarCode = resultado.geometry;

                delete resultado.properties;

                this.mostrarTerritorioNoMapa(
                    response.geometry,
                    this.valorPesquisado
                );
                return;
            } catch {
                this.$notify.error({
                    message: translate.getMessage(
                        'mensagens.menuMapa.notificacoes.naoFoiPossivelConsultarCar'
                    )
                });
                this.clearLayers();
            }
        },

        async buscarSigef() {
            try {
                const { data } = await SigefService.buscarGeometriaParcela(
                    this.valorPesquisado
                );
                if (data !== '') {
                    const geometriaSigef = JSON.parse(data);

                    this.mostrarTerritorioNoMapa(
                        geometriaSigef,
                        this.valorPesquisado
                    );
                    return;
                } else {
                    this.$notify.warning(
                        translate.getMessage(
                            'mensagens.menuMapa.notificacoes.parcelaNaoEncontrada'
                        )
                    );
                    this.clearLayers();
                    return;
                }
            } catch (error) {
                this.$notify.error({
                    message: translate.getMessage(
                        'mensagens.menuMapa.notificacoes.parcelaNaoEncontrada'
                    )
                });
                this.clearLayers();
            }
        },

        clearLayers() {
            if (this.geometria) {
                this.mapa.removeLayer(this.geometria);
                this.geometria = null;
                store.dispatch('setCarSelecionadoNaPopup', null);
            }
        },

        mostrarTerritorioNoMapa(geometria, identificadorGeometria) {
            this.geometria = Mapa.criarGeoJSON(
                geometria,
                mapaEstilos.Geometria.car
            );
            this.geometria.identificadorGeometria = identificadorGeometria;
            this.mapa.addLayer(this.geometria);
            var bounds = this.geometria.getBounds();

            // Fit the map to the polygon bounds
            this.mapa.fitBounds(bounds);

            let layer = Object.values(this.geometria._layers)[0];
            layer.layerType = 'polygon';
            EventBus.$emit('retorna-geometria-car', layer);
        },

        mostrarTerritorioNoMapaPY(dadosOutputApi, valorPesquisado) {
            this.clearLayers();
            for (let geom of dadosOutputApi) {
                this.geometria = Mapa.criarGeoJSON(
                    geom.geometria,
                    mapaEstilos.Geometria.imovelRuralCandidato
                );

                this.geometria.identificadorGeometria = valorPesquisado;
                this.mapa.addLayer(this.geometria);
            }
        }
    }
};
</script>

<style lang="scss">
#botao-busca-car {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    color: var(--black);
    padding: 0 !important;
}

#botao-busca-finca-or-padron {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    color: var(--black);
    padding: 0 !important;
}

.buscaCar-container {
    display: flex;
    height: 31px;

    .input input {
        height: 31px;
        width: 300px;
        border-radius: 0;
    }
}
</style>
